import { Box, Button, Grid } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedCheckboxRHF,
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

interface IPayrollInfoSetupFieldsPanel {
	formMethods: any;
	payPeriodFrequencyDDLItems: any;
	payPeriodEndDateDDL: any;
	onPeriodEndDateSelectionChangeHandler: (value: string) => void;
	isExporting: boolean;
	handleImportClick: (tag: string) => void
	exportDataPageName: string;
}


export const PayrollInfoSetupFieldsPanel: FC<
	IPayrollInfoSetupFieldsPanel
> = ({ onPeriodEndDateSelectionChangeHandler, formMethods, payPeriodFrequencyDDLItems, payPeriodEndDateDDL, handleImportClick, isExporting, exportDataPageName }) => {

	const [isEndDateDisabled, setIsEndDateDisabled] = useState<boolean>(true);
	const [stateIsDateRangeDisabled, setStateIsDateRangeDisabled] = useState<boolean>(false);
	const currentYear = new Date().getFullYear();

	const onPayPeriodSelectionChangeHandler = (e: any) => {
		// setStateRunGetListAPICall(false)
		onPeriodEndDateSelectionChangeHandler(e.value);
		setIsEndDateDisabled(e.value === "all")

		if (e.value === "all") {
			formMethods.setValue("payPeriodEndDate", "all");
			setStateIsDateRangeDisabled(false)
		}
	}

	const onPayPeriodEndDateSelectionChangeHandler = ({ value }: any) => {

		// setStateRunGetListAPICall(false);

		const isAll = value === "all";
		setStateIsDateRangeDisabled(!isAll);

		if (isAll) return;
		const selectedLabel = payPeriodEndDateDDL && payPeriodEndDateDDL?.find(
			(item: any) => item.value === value
		)?.label;

		if (!selectedLabel) return;

		// const [startDate, endDate] = selectedLabel.split(" to ");

	};

	useEffect(() => {
		if (!stateIsDateRangeDisabled && !stateIsDateRangeDisabled) {
			formMethods.reset({
				...formMethods.getValues(),
				payrollSheduleId: "all",
				payPeriodEndDate: "all",
				exportRecordAs: 500,
				startDate: new Date(currentYear, 0, 1),
				endDate: new Date(),
			});
		}
	}, [stateIsDateRangeDisabled])

	return (
		<Box
			sx={{
				"& .MuiFormControlLabel-root": {
					marginBottom: "0!important",
					color: "rgba(0, 0, 0, 0.6)",
					fontSize: "0.875rem"
				},
				"& .MuiFormControlLabel-root .MuiTypography-root": {
					fontSize: "0.875rem",
				},
				"& .enhanced-button": {
					marginTop: "2rem",
				}
			}}>
			<EnhancedDropDownRHFWithLabel
				selectName={"payrollSheduleId"}
				items={payPeriodFrequencyDDLItems ?? []}
				selectedItem={"all"}
				label={"Pay Period Type"}
				testId={"pay-period-type-ddl"}
				// onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
				onSelectionChangeHandler={onPayPeriodSelectionChangeHandler}
			/>

			<EnhancedDropDownRHFWithLabel
				selectName={"payPeriodEndDate"}
				items={payPeriodEndDateDDL ?? []}
				selectedItem={"all"}
				label={"End Date"}
				testId={"end-date-ddl"}
				// // onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
				onSelectionChangeHandler={onPayPeriodEndDateSelectionChangeHandler}
				isDisabled={isEndDateDisabled}

			/>
			{!stateIsDateRangeDisabled && <Grid
				container
				spacing={2}
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
			>
				<Grid
					size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}
					sx={{
						"& .MuiBox-root": {
							paddingTop: "3px !important",
						},
						"& .calenderWrapper": {
							width: "100% !important",
							minWidth: "unset !important",
						},
					}}
				>
					<RHookFormDatePicker
						name="startDate"
						testId="start-date"
						label="From"
						format="M dd, yy"
						defaultValue={new Date(currentYear, 0, 1)}
					/>
				</Grid>

				<Grid
					size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}
					sx={{
						"& .MuiBox-root": {
							paddingTop: "3px !important",
						},
						"& .calenderWrapper": {
							// marginTop: "19px !important",
							marginBottom: "0 !important",
							width: "100% !important",
							minWidth: "unset !important",
						},
					}}
				>
					<RHookFormDatePicker
						name="endDate"
						testId="end-date"
						label="To"
						format="M dd, yy"
						defaultValue={new Date()}
					/>
				</Grid>
			</Grid>}

{exportDataPageName !== "quick_books" && <>
			<RHookFormDatePicker
				name="paymentDate"
				testId="transaction-date"
				label="Transaction Date"
				format="M dd, yy"
			// disabled={stateIsDateRangeDisabled}
			// onDateSelectionChangeHandler={onEndDateSelectionChnageHandler}
			/>
			<EnhancedDropDownRHFWithLabel

				selectName="exportRecordAs"
				label="Export Record as"
				labelPosition={LabelPosition.Top}
				testId={`export-record-as`}
				items={[
					{ label: "Single entry for a Pay Period", value: 500 },
					{ label: "Group by Expense Category", value: 300 },
					{ label: "Group by Department", value: 200 },
					{ label: "Seperate entry for each Employee", value: 400 },
					{ label: "Combined entry for all selected pay periods", value: 100 },
				]}
				selectedItem={500}
				labelColumns={4}
				fieldColumns={8}
			/>

			<EnhancedCheckboxRHF
				name="exportPayroll"
				checked={false}
				testId="exportPayroll"
				checkboxLabel="Export Payroll"
			/>
			<EnhancedCheckboxRHF
				name="exportRqRemittance"
				checked={false}
				testId="exportRqRemittance"
				checkboxLabel="Export Rq Remittance"
			/>
			<EnhancedCheckboxRHF
				name="exportCraRemittance"
				checked={false}
				testId="exportCraRemittance"
				checkboxLabel="Export Cra Remittance"
			/>
			<EnhancedCheckboxRHF
				name="exportEhtRemittance"
				checked={false}
				testId="exportEhtRemittance"
				checkboxLabel="Export Eht Remittance"
			/>
			<EnhancedCheckboxRHF
				name="exportWsibRemittance"
				checked={false}
				testId="exportWsibRemittance"
				checkboxLabel="Export Wsib Remittance"
			/>
			<EnhancedCheckboxRHF
				name="includeNonCash"
				checked={false}
				testId="includeNonCash"
				checkboxLabel="Export include Non Cash"
			/>
			<EnhancedCheckboxRHF
				name="trackingCategories"
				checked={false}
				testId="trackingCategories"
				checkboxLabel="Tracking Categories"
			/>
			</>}

			{exportDataPageName === "quick_books" && <>
				<RHookFormTextFieldWithLabel
					label="G/L Reference"
					id="glReference"
					testId={`gl-reference`}
					labelPosition={LabelPosition.Top}
				/>
				<EnhancedTextAreaFieldRHF
					label="Memo"
					id="memo"
					testId={`memo`}
					labelPosition={LabelPosition.Top}
				/>
				<EnhancedDropDownRHFWithLabel
					selectName="exportAs"
					label="Export as"
					labelPosition={LabelPosition.Top}
					testId={`export-as`}
					items={[
						{ label: "Employee", value: 200 },
						{ label: "Departments", value: 100 },
					]}
					selectedItem={200}
				/>
				<EnhancedCheckboxRHF
					name="accountDescriptionInDescriptionField"
					checked={false}
					testId="Account-description-in-description-field"
					checkboxLabel="Account description in description field."
				/>
				<EnhancedCheckboxRHF
					name="employeeCodeInInDescriptionField"
					checked={false}
					testId="Employee-code-in-description-field"
					checkboxLabel="Employee code in description field."
				/>
				<EnhancedCheckboxRHF
					name="employeeNameInDescriptionField"
					checked={false}
					testId="Employee-Name-in-description-field"
					checkboxLabel=" Employee Name in description field."
				/>
				<EnhancedCheckboxRHF
					name="chequeNoInDescriptionFielWithpayrollClearIngentry"
					checked={false}
					testId="Cheque-no-in-description-field-with-payroll-clearing-entry"
					checkboxLabel="Cheque No. in description field with payroll clearing entry."
				/>
				<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
					<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ marginBottom: "1rem" }} >
						<span style={{ color: "#c0c0c0", fontSize: ".775rem" }}>
							Note: <br />
							Employee: Data will be exported as journal entry.
						</span><br />
						<span style={{ color: "#c0c0c0", fontSize: ".775rem" }}>
							Department: Data will be exported as bill.
						</span><br />
					</Grid>
				</Grid>
			</>}
				<EnhancedButtonPrimeReact
				label={exportDataPageName === "quick_books" ? "Export to QuickBooks" : "Export"}
				// type="submit"
				raised
				severity={EnhancedButtonPrimeReactSeverity.Secondary}
				loading={isExporting}
				onClickHandler={() => handleImportClick("payroll")}
			/>
		</Box>
	);
};
